module.exports = __webpack_public_path__ + "img/NL.52c64c60.webp";